export default __webpack_public_path__ + "static/media/logo.b88bc269.svg";